import axios from 'axios';

export default async function getLocationGroupResponsibles({ accessToken, locationGroupId }) {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_LOCATION_GROUPS_API_URL}/get-relation/responsibles/${locationGroupId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    return null;
  }
}
